export default __webpack_public_path__ + "static/media/EXIT.48df6884.jpg";